import React from 'react'

import InternationalTemplate from './templates/InternationalTemplate'
import AirfareTemplate from './templates/AirfareTemplate'
import HotelsTemplate from './templates/HotelsTemplate'
import Page from '../../../components/pdf/Page'
import DisneyTemplate from './templates/DisneyTemplate'

const PdfDocument = ({ templateId }) => {
  const content = () => {
    if (templateId === 4) {
      return <HotelsTemplate />
    }
    if (templateId === 5) {
      return <AirfareTemplate />
    }
    if (templateId === 6) {
      return <InternationalTemplate />
    }
    if (templateId === 7) {
      return <DisneyTemplate />
    }
  }
  return <Page>{content()}</Page>
}

export default PdfDocument
